import React, { useEffect } from 'react';
import styled from 'styled-components';

import PageVisibility from 'react-page-visibility';
import { UserInfoConsumer } from '../../contexts/UserInfo';

import HeadingBlock from './HeadingBlock';
import BusinessCards from './BusinessCards';
import Tariffs from './Tariffs';
import ReputationCards from './ReputationCards';
import Categories from './Categories';
import BlueBlock from './BlueBlock';
import BgBalls from './assets/balls.svg';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${BgBalls});
  background-repeat: no-repeat;
  background-position: center top 60px;
  overflow: hidden;
`;

const Home = ({ subscriptionIsActive, subscriptionIsPro }) => {
  useEffect(() => {
    (window.dataLayer || []).push({
      event: 'page_view_business',
      page_name: 'home',
    });
  }, []);

  return (
    <PageVisibility>
      {visible =>
        visible ? (
          <Wrapper>
            <HeadingBlock />
            <BusinessCards subscriptionIsActive={subscriptionIsActive} />
            <Tariffs subscriptionIsActive={subscriptionIsActive} />
            <ReputationCards />
            <Categories />
            <BlueBlock />
          </Wrapper>
        ) : null
      }
    </PageVisibility>
  );
};

export default () => (
  <UserInfoConsumer>{props => <Home {...props} />}</UserInfoConsumer>
);
